import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@commenda/kakashi';
import { RootfiCompanyUseCase } from '@prisma/client';

import { useRootFiInviteLinkConnectModal } from '../hooks/useRootFiInviteLinkConnectModal';
import type { RootFiInviteLinkConnectModalProps } from '../types/rootFiInviteLinkConnectModal';

import RootFiInviteLinkConnectModalIntegrationPicker from './RootFiInviteLinkConnectModalIntegrationPicker';
import { RootFiSyncConfigurationFields } from './RootFiSyncConfigurationFields';

const RootFiInviteLinkConnectModal = (
  props: RootFiInviteLinkConnectModalProps
) => {
  const { isOpen, onClose, useCases, showSyncConfiguration = false } = props;
  const {
    isDefaultsLoading,
    isSubmitting,
    selectedIntegration,
    integrationChoicesForPicker,
    syncSettings,
    onSyncSettingsChange,
    onSelectedIntegrationChange,
    canSubmit,
    onSubmit,
  } = useRootFiInviteLinkConnectModal(props);

  const isSyncConfigurationEnabled =
    showSyncConfiguration && useCases.includes(RootfiCompanyUseCase.SALES_TAX);
  const showSyncConfig =
    isSyncConfigurationEnabled &&
    selectedIntegration != null &&
    !isDefaultsLoading &&
    syncSettings.length > 0;
  const showFooter = isSyncConfigurationEnabled && selectedIntegration != null;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-[600px] max-h-[90vh] flex flex-col gap-0 p-0 overflow-hidden">
        <DialogDescription className="sr-only">
          Pick an integration to connect.
        </DialogDescription>
        <DialogHeader className="shrink-0 px-3xl pt-3xl pb-xl">
          <DialogTitle>Connect integration</DialogTitle>
        </DialogHeader>

        <RootFiInviteLinkConnectModalIntegrationPicker
          isDefaultsLoading={isDefaultsLoading}
          isSubmitting={isSubmitting}
          selectedIntegration={selectedIntegration}
          integrationChoicesForPicker={integrationChoicesForPicker}
          onSelectedIntegrationChange={onSelectedIntegrationChange}
          showSelectedIntegration={isSyncConfigurationEnabled}
        />

        {showSyncConfig ? (
          <div className="flex flex-col gap-3xl overflow-y-auto px-3xl pb-md pt-lg">
            <RootFiSyncConfigurationFields
              settings={syncSettings}
              onChange={onSyncSettingsChange}
            />
          </div>
        ) : null}

        {showFooter ? (
          <DialogFooter className="shrink-0 px-3xl pb-3xl pt-lg">
            <Button variant="secondary" size="md" onClick={onClose}>
              Cancel
            </Button>
            <Button
              size="md"
              onClick={onSubmit}
              disabled={!canSubmit || isDefaultsLoading}
              isLoading={isSubmitting}
            >
              Continue
            </Button>
          </DialogFooter>
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export type { RootFiInviteLinkConnectModalProps } from '../types/rootFiInviteLinkConnectModal';
export { RootFiInviteLinkConnectModal };
